import React, { ReactNode } from 'react';
import { Icon, Modal } from '@common/components';
import { PdfPreview } from '@common/components/pdf-preview';
import { Spacing } from 'works/legacy/lib/style-helper';

type Props<T> = {
  children?: ReactNode;
  visible?: boolean;
  trigger?: ReactNode;
  title?: string;
  onCancel: () => void;
  assets: T[];
  // @TODO: transform this prop in optional receiving resolveByUrl as default
  resolveAsset: (file: T) => { embed: boolean; url: string };
};

// Naive approach, works for the ones that are already uploaded
// and returned by server, but fails for non uploaded files
export const resolveByUrl = (url: string) => ({
  embed: url.includes('.pdf'),
  url: url,
});

/**
 * @deprecated This component is deprecated. Use `FileViewer` from `@common/components` instead.
 */
export const DocumentPreviewModalDeprecated = <T,>({
  assets,
  visible,
  children,
  trigger,
  title,
  onCancel,
  resolveAsset,
}: Props<T>) => (
  <Modal
    visible={visible}
    footer={null}
    trigger={trigger}
    title={title}
    onOk={onCancel}
    onCancel={onCancel}
    okText="Close"
    hideCancelButton
  >
    <article className="document-preview-container">
      {!assets?.length ? (
        <>No document found.</>
      ) : (
        assets.map((asset) => {
          const { embed, url } = resolveAsset(asset);
          const preview = embed ? (
            <PdfPreview assetUrl={url} height="590px" />
          ) : (
            <img className="document-preview-image" src={url} />
          );

          return (
            <React.Fragment key={url}>
              {preview}
              <a
                rel="noopener noreferrer"
                target="_blank"
                className="document-preview-download-button"
                href={url}
              >
                <Icon icon="cloudDownloadAlt" kind="light" size="md" />
                &nbsp; Download Document
              </a>
            </React.Fragment>
          );
        })
      )}
    </article>
    <section className="document-preview-details">{children}</section>
    <style jsx>{`
      .document-preview-container {
        padding-top: ${Spacing.baseSpacingPx};
      }
      .document-preview-image {
        width: 100%;
        max-width: 460px;
        max-height: 590px;
      }
      .document-preview-download-button {
        display: block;
        width: 100%;
        text-align: center;
        margin: ${Spacing.baseSpacing / 2}px 0;
      }
      .document-preview-details {
        margin-top: ${Spacing.baseSpacing}px;
      }
    `}</style>
  </Modal>
);
